<template>
  <MDBRow>
    <MDBCol lg="4" md="6" class="mb-4" v-for="(price, i) in priceLists" :key="i" :class="{ 'd-none': !price.show }">
      <Card :data="price" v-if="price.show" minHeight="container-height" :linkText="price.linkText"
        :simpleLink="price.simpleLink" :target="price.target" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { computed } from "vue";
import Card from "@/components/General/Card/index.vue";
import { useStore } from "vuex";
import { useI18n } from 'vue-i18n'
import { useTenantConfig } from "@/composables/useTenantConfig";

const { tenantConfig } = useTenantConfig();
const store = useStore();
const { t } = useI18n()

const currentLocale = computed(() => store.getters.getCurrentLocale);

const priceLists = computed(() => [
  {
    name: t("priceList.productInfo.index.categories.carApprovals.title"),
    link: 'https://freigaben.bridgestone.de',
    description: t(
      "priceList.productInfo.index.categories.carApprovals.description"
    ),
    image: require(`@/assets/img/pkw_freigaben.png`),
    show: tenantConfig.value.showPkwQuestion,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: true,
    target: "_blank",
  }, {
    name: t("priceList.productInfo.index.categories.carApprovalsFS.title"),
    link: 'https://freigaben.firestone.de',
    description: t(
      "priceList.productInfo.index.categories.carApprovalsFS.description"
    ),
    image: require(`@/assets/img/pkw-firestone.jpg`),
    show: tenantConfig.value.showPkwFsQuestion,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: true,
    target: "_blank",
  },
  {
    name: t("priceList.productInfo.index.categories.motApprovals.title"),
    link: 'https://motorradfreigaben.info/#suche',
    description: t(
      "priceList.productInfo.index.categories.motApprovals.description"
    ),
    image: require(`@/assets/img/mot_freigaben.png`),
    show: tenantConfig.value.showMotQuestion,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: true,
    target: "_blank",
  },
  {
    name: t("priceList.productInfo.index.categories.productBrochures.title"),
    link: { name: "brochure_prices" },
    description: t(
      "priceList.productInfo.index.categories.productBrochures.description"
    ),
    image: require(`@/assets/img/brochures/produktbroschuren_${currentLocale.value.slice(0, 2)}.png`),
    show: tenantConfig.value.showBrochurePrices,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: false,
    target: "_self",
  },
  {
    name: t("global.menu.productBrochures"),
    link: { name: "produktbroschuren" },
    description: t("priceList.productInfo.index.categories.productBrochures.description"),
    image: require(`@/assets/img/brochures/produktbroschuren_${currentLocale.value.slice(0, 2)}.png`),
    show: tenantConfig.value.showProductBrochures,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: false,
    target: "_self",
  },
  {
    name: t("priceList.productInfo.categories.priceList"),
    link: { name: "preislistenList" },
    description: t("priceList.priceDescription"),
    image: require(`@/assets/img/price_list_${currentLocale.value.slice(0, 2)}.png`),
    show: tenantConfig.value.showPriceList,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: false,
    target: "_self",
  },
  {
    name: t("global.nav.pricat"),
    link: { name: "pricat" },
    description: t("priceList.pricatDescription"),
    image: require("@/assets/img/pricat.png"),
    show: tenantConfig.value.showPricat,
    linkText: t("global.buttons.toDiscover"),
    simpleLink: false,
    target: "_self",
  },
]);
</script>
